import { lazy, memo } from "react";
import { loanDrilldownSidebarTypes } from "../../../constants/enums/loanDrilldownScreenSidebarOptions";
import DrilldownCreateNewItemSidebar from "./types/DrilldownCreateNewItemSidebar";
import DrilldownSidebarAddEditLoanCondition from "./types/DrilldownSidebarAddEditLoanCondition";
import DrilldownSidebarUpdateBorrowerData from "./types/DrilldownSidebarUpdateBorrowerData";
import DrilldownSidebarEmailComposer from "./types/DrilldownSidebarEmailComposer";

// Lazy load sidebar components
const DrilldownFilePreviewSidebar = lazy(
  () => import("./types/DrilldownFilePreviewSidebar"),
);

const DrilldownSidebarAddBorrower = lazy(
  () => import("./types/DrilldownSidebarAddBorrower"),
);
const DrilldownSidebarAddLoanRelatedContact = lazy(
  () => import("./types/DrilldownSidebarAddLoanRelatedContact"),
);
const DrilldownSidebarAddException = lazy(
  () => import("./types/DrilldownSidebarAddException"),
);
const DrilldownSidebarAddProperty = lazy(
  () => import("./types/DrilldownSidebarAddProperty"),
);

const DrilldownSidebarEnhancedComments = lazy(
  () => import("./types/DrilldownSidebarEnhancedComments"),
);
const DrilldownSidebarLoanChangeHistory = lazy(
  () => import("./types/DrilldownSidebarLoanChangeHistory"),
);
const DrilldownSidebarFormSpy = lazy(
  () => import("./types/DrilldownSidebarFormSpy"),
);
const DrilldownSidebarLoanTotals = lazy(
  () => import("./types/DrilldownSidebarLoanTotals"),
);
const DrilldownSidebarUnderwritingChecklist = lazy(
  () => import("./types/DrilldownSidebarUnderwritingChecklist"),
);
const DrilldownSidebarUnderwritingNotes = lazy(
  () => import("./types/DrilldownSidebarUnderwritingNotes"),
);
// ----
const DrilldownSidebarAddLoanFee = lazy(
  () => import("./types/DrilldownSidebarAddLoanFee"),
);

const DrilldownSidebarAddEditLoanCredit = lazy(
  () => import("./types/DrilldownSidebarAddEditLoanCredit"),
);
const DrilldownSidebarAddEditTermSpecialConditions = lazy(
  () => import("./types/DrilldownSidebarAddEditTermSpecialConditions"),
);
const DrilldownSidebarAddEditBrokerTerms = lazy(
  () => import("./types/DrilldownSidebarAddEditBrokerTerms"),
);
const DrilldownSidebarAddEditCorrespondentFee = lazy(
  () => import("./types/DrilldownSidebarAddEditCorrespondentFee"),
);
const DrilldownSidebarAddEditThirdPartyFee = lazy(
  () => import("./types/DrilldownSidebarAddEditThirdPartyFee"),
);
const DrilldownSidebarAddEditEscrowItem = lazy(
  () => import("./types/DrilldownSidebarAddEditEscrowItem"),
);
const DrilldownSidebarAddEditEntity = lazy(
  () => import("./types/DrilldownSidebarAddEditEntity"),
);
const DrilldownSidebarAddEditEntityMember = lazy(
  () => import("./types/DrilldownSidebarAddEditEntityMember"),
);

const DrilldownSidebarContentRenderer = memo(({ type }) => {
  switch (type) {
    case loanDrilldownSidebarTypes.CREATE_NEW:
      return <DrilldownCreateNewItemSidebar />;
    case loanDrilldownSidebarTypes.FILE_PREVIEW:
      return <DrilldownFilePreviewSidebar />;

    case loanDrilldownSidebarTypes.FORMSPY:
      return <DrilldownSidebarFormSpy />;
    case loanDrilldownSidebarTypes.COMMENTS:
      return <DrilldownSidebarEnhancedComments />;

    case loanDrilldownSidebarTypes.UW_NOTES:
      return <DrilldownSidebarUnderwritingNotes />;

    case loanDrilldownSidebarTypes.UW_CHECKLIST:
      return <DrilldownSidebarUnderwritingChecklist />;
    case loanDrilldownSidebarTypes.ADD_BORROWER:
      return <DrilldownSidebarAddBorrower />;
    case loanDrilldownSidebarTypes.EDIT_BORROWER:
      return <DrilldownSidebarUpdateBorrowerData />;
    case loanDrilldownSidebarTypes.ADD_LOAN_RELATED_CONTACT:
      return <DrilldownSidebarAddLoanRelatedContact />;
    case loanDrilldownSidebarTypes.ADD_LOAN_FEE:
      return <DrilldownSidebarAddLoanFee />;
    case loanDrilldownSidebarTypes.ADD_LOAN_CREDIT:
      return <DrilldownSidebarAddEditLoanCredit />;
    case loanDrilldownSidebarTypes.ADD_LOAN_SPECIAL_CONDITION:
      return <DrilldownSidebarAddEditTermSpecialConditions />;
    case loanDrilldownSidebarTypes.ADD_EDIT_BROKER_TERMS:
      return <DrilldownSidebarAddEditBrokerTerms />;
    case loanDrilldownSidebarTypes.ADD_EDIT_LOAN_CONDITION:
      return <DrilldownSidebarAddEditLoanCondition />;
    case loanDrilldownSidebarTypes.ADD_EDIT_CORRESPONDENT_FEE:
      return <DrilldownSidebarAddEditCorrespondentFee />;
    case loanDrilldownSidebarTypes.ADD_EDIT_THIRD_PARTY_FEES:
      return <DrilldownSidebarAddEditThirdPartyFee />;
    case loanDrilldownSidebarTypes.ADD_LOAN_ESCROW_ITEM:
      return <DrilldownSidebarAddEditEscrowItem />;
    case loanDrilldownSidebarTypes.LOAN_TOTALS:
      return <DrilldownSidebarLoanTotals />;
    case loanDrilldownSidebarTypes.LOAN_CHANGE_HISTORY:
      return <DrilldownSidebarLoanChangeHistory />;
    case loanDrilldownSidebarTypes.ADD_EXCEPTION:
      return <DrilldownSidebarAddException />;
    case loanDrilldownSidebarTypes.ADD_PROPERTY:
      return <DrilldownSidebarAddProperty />;
    case loanDrilldownSidebarTypes.ADD_EDIT_ENTITY:
      return <DrilldownSidebarAddEditEntity />;
    case loanDrilldownSidebarTypes.ADD_EDIT_ENTITY_MEMBER:
      return <DrilldownSidebarAddEditEntityMember />;
    case loanDrilldownSidebarTypes.EMAIL_COMPOSER:
      return <DrilldownSidebarEmailComposer />;
    default:
      return null;
  }
});

export default DrilldownSidebarContentRenderer;
